var React = require('react');

function SCrossLarge18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.70593,13.28266,10.42326,9l4.28267-4.28266a.9999.9999,0,0,0-1.41166-1.41648h0L9.0092,7.58594,4.72654,3.30327A.99991.99991,0,0,0,3.31,4.71489L7.59514,9,3.31247,13.28266a.9999.9999,0,0,0,1.411,1.41716l.00069-.00068L9.0092,10.41406l4.28266,4.28267A.9999.9999,0,1,0,14.7083,13.285Z","fill":"var(--iconFill, #464646)"}));
}

SCrossLarge18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SCrossLarge18N;

SCrossLarge18N.default = SCrossLarge18N;
